/** Dispatched after login / logout / register so shell + header re-read session cookies. */
export const AUTH_SESSION_CHANGED = "auth:session-changed";

export function broadcastAuthSessionChanged(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(AUTH_SESSION_CHANGED));
}

/**
 * After `router.push` from auth routes, MainShell/MainHeader mount on the next frame.
 * Broadcast then so listeners exist; also pairs with sync `getCookieSync` in `useLayoutEffect`.
 */
export function broadcastAuthSessionChangedDeferred(): void {
  if (typeof window === "undefined") return;
  window.setTimeout(() => broadcastAuthSessionChanged(), 0);
}
